import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { NewLeadBaseStore } from '../stores/newLeadBaseStore';

export const useNewLeadStore = () =>
  useContext<{
    newLeadStore: NewLeadBaseStore;
  }>(StoreContext);
